import React from 'react';
import PageHeader from '../../components/PageHeader';

const ProtocolsListHeader = () => <PageHeader title="Protocols" />;

export default ProtocolsListHeader;
